import SkorDefaultLoader from "../assets/img/skorDefaultLoader.gif";

const Loader = () => {
  return (
    <div className="global-loader">
      <div className="child-loader">
        <img
          src={SkorDefaultLoader}
          className="defaultSkorLoader"
          alt="Example"
        />
      </div>
    </div>
  );
};

export default Loader;
